export const education = [
  {
    id: 1,
    degree: "B.S. Computer Science",
    field: "Computer Science",
    institution: "Virtual University of Pakistan",
    institutionUrl: "https://vu.edu.pk",
    location: "Hyderabad, Pakistan",
    startYear: "2022",
    endYear: "2026",
    gpa: "3.38",
    honors: null,
    coursework: [
      "Data Structures & Algorithms",
      "Database Management Systems",
      "Data Communication",
      "Operating Systems",
      "Web Development",
      "Software Engineering",
      "Computer Networks",
      "Object-Oriented Programming",
      "Discrete Mathematics",
      "Calculus",
      "Digital Logic Design",
      "Assembly Language",
      "Statistics & Probability",
      "Operating Systems",
      "Cloud Computing",
      "System Programming",
      "Numerical Analysis",
      "Artificial Intelligence",
    ],
    activities: [
      "Final Year Project: AlgoViz — Interactive Algorithm Visualizer (React)",
    ],
  },
  {
    id: 2,
    degree: "Advanced Diploma in Software Engineering",
    field: "Software Engineering",
    institution: "Aptech Computer Education",
    institutionUrl: "https://aptech-education.com.pk",
    location: "Hyderabad, Pakistan",
    startYear: "2020",
    endYear: "2023",
    gpa: null,
    honors: null,
    coursework: [
      "Logic Building & Programming",
      "Building NextGen Websites",
      "JavaScript",
      "BootStrap & Jquery",
      "AngularJS",
      "UI/UX for Responsive Design",
      "Markup Language & JSON",
      "SQL Server",
      "Distributed Version Control",
      "Content Management System",
      "SEO",
      "Querying with MySQL",
      "PHP",
      "Laravel",
      "Securing Web Applications",
      "C#",
      "ASP.Net MVC",
      "Java",
      "Android Development",
      "Agile & DevOps",
      "Python",
      "R Programming",
      "IoT",
      "MS Office",
    ],
    activities: [],
  },
];
